import type { RouteObject } from 'react-router-dom';
import { ErrorBoundary, UnsavedChangesProvider } from '@yingbaba/ui';
import { App } from './App';

// The browser and SSR use the same route tree, including edit protection.
export const websiteRoutes: RouteObject[] = [
  {
    path: '*',
    element: (
      <ErrorBoundary>
        <UnsavedChangesProvider>
          <App />
        </UnsavedChangesProvider>
      </ErrorBoundary>
    ),
  },
];
